import { Controller } from "@hotwired/stimulus"

// Controller for handling the recurrence dropdown on task forms
// Shows/hides custom fields when "Custom..." is selected
export default class extends Controller {
  static targets = ["select", "customFields", "dayOfMonth", "month"]

  toggle() {
    // Only toggle custom fields if they exist (not present in inline form)
    if (!this.hasCustomFieldsTarget) return

    const value = this.selectTarget.value

    if (value === "custom") {
      this.customFieldsTarget.classList.remove("hidden")
    } else {
      this.customFieldsTarget.classList.add("hidden")
    }
  }
}
